var React = require('react');

function IconBubble (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-bubble","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"id":"Oval","d":"M5,19 C5,19.7590597 5.8124785,20.2413731 6.47885318,19.877895 L10.1818383,17.8580792 C10.7756685,17.952165 11.3839785,18 12,18 C16.918278,18 21,14.9387085 21,11 C21,7.0612915 16.918278,4 12,4 C7.081722,4 3,7.0612915 3,11 C3,12.6568761 3.72521186,14.2213649 5,15.444468 L5,19 Z M7,17.3154555 L7,15 C7,14.7058156 6.87046302,14.4265555 6.64586822,14.2365511 C5.58317265,13.3375239 5,12.1885693 5,11 C5,8.3112915 8.081722,6 12,6 C15.918278,6 19,8.3112915 19,11 C19,13.6887085 15.918278,16 12,16 C11.3850236,16 10.7811048,15.9426989 10.198336,15.8307943 C9.97051186,15.7870469 9.73456524,15.8238702 9.53090559,15.9349576 L7,17.3154555 Z"})));
}

IconBubble.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = IconBubble;

IconBubble.default = IconBubble;
